import { Component, OnInit, ViewChild,ElementRef } from '@angular/core';
import { LeadsService } from '../../_service/leads.service';
import { SharedService } from '../../_service/shared.service';
import { ActivatedRoute, Router  } from '@angular/router';
import {PageEvent} from '@angular/material/paginator';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';

@Component({
  selector: 'app-view-lead',
  templateUrl: './view-lead.component.html',
  styleUrls: ['./view-lead.component.css']
})
export class ViewLeadComponent implements OnInit {
    leadForm: FormGroup;
    perpage:number=25;leads:any=[];length:number=0;pageEvent: PageEvent;loading:boolean=true;myrole:string;
    pageSizeOptions = [10,25,50,100,200];pageIndex:number=0;leadStatus=[];bds=[];loaded:boolean=false;circles=[];
    start_date:string='';end_date:string='';treatments=[];search:string='';circle:any;
    submitted:boolean=false;histories=[];lead_id:string;allData={};doctorList=[];
    
    @ViewChild('dateRangeStart', {static: false}) dateRangeStart: ElementRef;
    @ViewChild('dateRangeEnd', {static: false}) dateRangeEnd: ElementRef;
    
    constructor(private formBuilder: FormBuilder, private leadapi:LeadsService,private sharedapi:SharedService,private router:Router, private route:ActivatedRoute)
    {
        this.leadForm = this.formBuilder.group({ 
            'lead_name' : [null, Validators.required],
            'lead_mobile' : [null, Validators.required],
            'lead_city' : [null],
            'doctor' : [null],
            'circle' : [null, Validators.required],
            'lead_owner' : [null, Validators.required],
            'treatment' : [null, Validators.required],
            'description' : [null],
            'lead_status' : [null, Validators.required],
            'followup_date' : [null, Validators.required],
            'payment_mode' : [null]
        });
    }

    ngOnInit(): void 
    {
        this.sharedapi.getRole()
        .subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.lead_id = this.route.snapshot.paramMap.get("lead_id");
        this.getbds();this.getcircle();
        this.getleadStatus();this.getTreatment();
        setTimeout (() => {
        this.getLeadDetails();
        },2000);
        this.loadLeadHistory(0,this.perpage);
        this.getDoctors();
    }

    async loadLeadHistory(pageIndex,perpage)
    {
        this.histories = [];
        let qString = 'search='+this.search+'&date_range='+this.start_date+'-'+this.end_date;
        this.loading = true;this.loaded = false;
        await this.leadapi.getLeadHistory(this.lead_id,pageIndex,perpage,qString).subscribe((data:any) => {
            this.length = parseInt(data.totaldata);
            this.loading = false;
            this.loaded = true;
            if(data.status)
            {
                this.histories = data.data;
            }else{
                this.histories = [];
            }
        }, error => {
            this.loading = false;
            this.loaded = true;
            this.sharedapi.checkError(error);
        });
    }

    pageChange(event)
    {
        this.pageIndex = event.pageIndex;
        this.loadLeadHistory(event.pageIndex,event.pageSize);
    }

    public getServerData(event:PageEvent):any
    {
        this.perpage = event.pageSize;
        this.pageIndex = event.pageIndex;
        this.loadLeadHistory(event.pageIndex,event.pageSize);
    }

    dateRangeChange(date1,date2)
    {
        if(date2.value)
        {
            this.start_date = date1.value;
            this.end_date = date2.value;
            this.loadLeadHistory(0,this.perpage);
        }
    }
    
    clearDate()
    {
        this.dateRangeStart.nativeElement.value = "";
        this.dateRangeEnd.nativeElement.value = "";
        this.start_date = '';
        this.end_date = '';
        this.loadLeadHistory(0,this.perpage);
    }

    async getleadStatus()
    {
        await this.leadapi.getLeadStatus().subscribe((data:any) => {
            if(data.status)
            {
                this.leadStatus = data.data;
            }else{
                this.leadStatus = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getbds()
    {
        await this.leadapi.getbds().subscribe((data:any) => {
            if(data.status)
            {
                this.bds = data.data;
            }else{
                this.bds = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }
    
    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getDoctors()
    {
        await this.leadapi.getdoctors().subscribe((data:any) => {
            if(data.status)
            {
                this.doctorList = data.data;
            }else{
                this.doctorList = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getLeadDetails()
    {
        await this.leadapi.getLeadDetail(this.lead_id).subscribe((data:any) => {
            if(data.status)
            {
                this.leadForm.setValue({ 
                    'lead_name' : data.data.lead_name,
                    'lead_mobile' : 'xxxxxxxxxx',
                    //'lead_mobile' : data.data.mobile,
                    'lead_city' : data.data.city_name,
                    'circle' : data.data.circle_id,
                    'lead_owner' : data.data.user_id,
                    'treatment' : data.data.treatment_id,
                    'description' : data.data.description,
                    'lead_status' : data.data.lead_status_id,
                    'followup_date' : data.data.followup_date,
                    'payment_mode' : data.data.payment_mode,
                    'doctor' : data.data.doctor_id,
                });
                
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    saveLead()
    {
        
    }

    

}
